import { render } from "./LucideIcon.vue?vue&type=template&id=41fbbf78"
import script from "./LucideIcon.vue?vue&type=script&lang=js"
export * from "./LucideIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__